import React from "react"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import NavBar from "../../components/navigation/NavBar"
import Footer from "../../components/footer/Footer"
import HowItWorks from "../../components/home/howItWorks/HowItWorks"
import KonzeptBanner from "../../components/konzept/KonzeptBanner"
import nextI18NextConfig from "../../next-i18next.config.js"
import {useTranslation} from "next-i18next"
import MbpHead from "../../components/head/MbpHead"
import {getPageData} from "../../pageData"
import {staticDataHowItWorks, staticDataHowSuggestionWorks} from "../../components/home/howItWorks/contentData"
import {useRouter} from "next/router"
import BannerWithForm from "../../components/BannerWithForm/BannerWithForm"
import Typography from "../../components/reusable/Typography/Typography"
import HomeCatBoxes from "../../components/home/homeCatBoxes/HomeCatBoxes"

const SuggestionPage = () => {
	const {t} = useTranslation()
	const {locale, query} = useRouter()
	const {slug} = query
	const title = t("MyBikePlan | Suggestion | Schweiz")
	const description = t("Du hast Fragen oder Anliegen zu unseren E-Bikes oder möchtest uns sonst etwas mitteilen? Schreib uns hier, wir freuen uns, von dir zu hören!")

	const dataHowItWorks = staticDataHowItWorks[locale]
	const dataHowSuggestionWorks = staticDataHowSuggestionWorks[locale]

	const typeformIds = {
		1: {de: "01HWWB0JR2JM51TCZYE1G7JYCZ", fr: "01J30TJVWJCJ444MGRJAXWGWQW"},
		2: {de: "01J2GFKMSXWK746Q1EPGTJWTST", fr: "01J2KKQ9833FDZ7YXCP7KNA7TY"},
		3: {de: "01J2GFZM2VAJBTZ393YCN614XT", fr: "01J2GFZM2VAJBTZ393YCN614XT"}, // Same ID for both locales
		4: {de: "01J3F8YETCPG9X44ZF1FKF7PFT", fr: "01J3F931KDVAD8S2H2BYM0DJ2M"},
		5: {de: "01JRCTFZBBR5HP3PC4WDKQRM5J", fr: "01JRCTFZBBR5HP3PC4WDKQRM5J"}, // Same ID for both locales
		6: {de: "01JRWQZ3BY4P87BRCMAS8G0KAY", fr: "01JRWQZ3BY4P87BRCMAS8G0KAY"}, // Same ID for both locales
		default: {de: "01HWWB0JR2JM51TCZYE1G7JYCZ", fr: "01HWWB0JR2JM51TCZYE1G7JYCZ"} // Default Typeform ID
	}

	const getTypeform = (slug, locale) => {
		const formId = typeformIds[slug]?.[locale] || typeformIds.default[locale]
		return (
			<>
				<div data-tf-live={formId}
					data-tf-inline-on-mobile
					style={{width: "100%"}}></div>
				<script src="//embed.typeform.com/next/embed.js"></script>
			</>
		)
	}

	return (
		<>
			<MbpHead>
				<title>{title}</title>
				<meta name="description"
					content={description} />
				<meta property="og:title"
					content={title} />
				<meta property="og:description"
					content={description} />
			</MbpHead>
			<NavBar />
			<main>
				<div className="my-md-5 py-md-5 mt-4 pb-5 mb-3 mb-md-0">
					<BannerWithForm
						bannerTitle={t("suggestion-eligible-for-financing-title")}
						listTitle={t("suggestion-banner-list-title")}
						listItemOne={t("suggestion-list-item-1")}
						listItemTwo={t("suggestion-list-item-2")}
						listItemThree={t("suggestion-list-item-3")}
						bgImageSrc={"/assets/images/suggestions-banner-desktop.png"}
						typeform={getTypeform(slug, locale)}
					/>
				</div>
				<div className="container mt-md-5">
					<HowItWorks blockTilesHowItWorks={dataHowSuggestionWorks} />
				</div>
				<HomeCatBoxes content={contentData}/>
				<div className="my-md-5 py-md-5">
					<HowItWorks blockTilesHowItWorks={dataHowItWorks}
						hasOptionalText/>
				</div>
				<div className="pb-md-5 mt-5 pt-3 mt-md-0 pt-md-0 container">
					<KonzeptBanner isCreditCheckPage />
				</div>
				<div className="my-5 pt-5 py-md-5 container">
					<Typography variant="bodyLgBold"
						semanticTag="span">{t("Bedingungen")}: </Typography>
					<Typography variant="bodyLg"
						semanticTag="span">
						{t("suggestion-notice-text")}
					</Typography>
				</div>
			</main>
			<Footer />
		</>
	)
}

export async function getStaticPaths() {
	const slugs = ["1", "2", "3", "4", "5", "6"]
	const locales = ["de", "fr"]

	const paths = slugs.flatMap(slug =>
		locales.map(locale => ({
			params: {slug},
			locale
		}))
	)

	return {
		paths,
		fallback: false
	}
}

export async function getStaticProps({params, locale}) {
	return {
		props: {
			...(await getPageData(locale, [])),
			...(await serverSideTranslations(locale, ["common", "URL", "search", "filters"], nextI18NextConfig))
		}
	}
}

export default SuggestionPage

const contentData = {
	de: [{
		fields: {
			title: "MyBikePlan.ch: Das flexibelste E-Bike-Angebot der Schweiz",
			collapsible: false,
			text: {
				content: [{
					nodeType: "paragraph",
					content: [{value: "Wir sind der grösste Online-Shop für E-Bikes auf Raten mit 0 % Finanzierung."}]
				}]
			}
		}
	}],
	fr: [{
		fields: {
			title: "MyBikePlan.ch : l'offre de (E)-Bikes la plus flexible de Suisse",
			collapsible: false,
			text: {
				content: [{
					nodeType: "paragraph",
					content: [{value: "On est le plus grand magasin en ligne de (E)-Bikes en paiements mensuels avec un financement à 0%."}]
				}]
			}
		}
	}]
}
